import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Spin } from 'antd';

const VideoLoadingIndicator = ({ initialisedVideoStreams }: { initialisedVideoStreams: boolean }) => {
  const { t } = useTranslation('common');
  if (initialisedVideoStreams) return null;
  return (
    <Row justify="center" align="middle" style={{ width: '100%', height: 200 }}>
      <Col>
        <Row justify="center" align="middle" style={{ marginBottom: 16 }}>
          <Spin />
        </Row>
        <Row justify="center" align="middle">
          <p>{t('Your video is loading...')}</p>
        </Row>
      </Col>
    </Row>
  );
};

export default VideoLoadingIndicator;
